import { dataResources } from '@portal-internet/core';

export const REDLFileTree = `{layoutURLHost}/web/dades/{path}`;
export const REDLStaticImages = `${dataResources.apiREDLImages}/web/dades/{path}`;
export const REDLLayouts = '/mapaweb/nodes/{node}/layouts';
export const REDLLayoutsSave = '/layouts';
